import { trackCustomEvent } from '@convivainc/conviva-js-appanalytics';
import uuid from 'react-uuid';
import { logEvent } from 'src/lib/events';
import { EventType } from 'src/lib/events/events';

import helper from './helper';

const convivaUuid = uuid();

const eventTracker = {
  // saarthi-events
  videoCallClickEvent: (mappingData: any, clickPop: string, islive: boolean) => {
    const startTime = new Date().getTime();
    const body = {
      origin: 'video_call_click',
      entry_time: startTime,
      coach_name: mappingData?.mentor_id?.first_name + mappingData?.mentor_id?.last_name,
      subject_name: mappingData?.subject_id?.name,
      popup: islive ? 'no' : 'yes',
      popup_type: islive ? 'default' : clickPop,
    };
    console.log(body);
    logEvent(EventType.VIDEO_CALL_CLICK, body);
  },
  pollEventReceived: (pollData: {
    poll_state: string;
    poll_id: string;
    schedule_id: any;
    received_time: number;
    start_time: string;
  }) => {
    const data = {
      ...pollData,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };

    logEvent(EventType.POLL_EVENT_RECEIVED, data);
  },

  pollID3EventReceived: (pollData: {
    poll_id: string;
    schedule_id: any;
    received_time: number;
    start_time: string;
    current_state: any;
  }) => {
    const data = {
      ...pollData,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };

    logEvent(EventType.POLL_ID3_EVENT_RECEIVED, data);
  },

  pollStatusChanged: (pollData: {
    poll_id: string;
    schedule_id: any;
    received_time: number;
    start_time: string;
    current_state: any;
  }) => {
    const data = {
      ...pollData,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };

    logEvent(EventType.POLL_STATUS_CHANGED, data);
  },
  pollReceived: (pollData: {
    poll_id: string;
    schedule_id?: any;
    received_time: number;
    start_time: number;
    lecture_type?: string;
  }) => {
    const data = {
      ...pollData,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };

    logEvent(EventType.POLL_RECEIVED, data);
  },
  recordPollReceived: (pollData: {
    poll_id: string;
    schedule_id?: any;
    received_time: number;
    start_time: number;
    lecture_type?: string;
  }) => {
    const data = {
      ...pollData,
    };

    logEvent(EventType.POLL_RECEIVED, data);
  },

  liveClassJoined: (data: {
    scheduleId: string;
    batchId: string;
    subjectId: string;
    video_type: string;
    video_start_time: string;
    student_joined_time: number;
    player_type: string;
  }) => {
    logEvent(EventType.LIVE_CLASS_JOINED, data);
  },
  liveClassLeft: (data: {
    scheduleId: string;
    batchId: string;
    subjectId: string;
    video_type: string;
    video_start_time: string;
    student_left_time: number;
    player_type: string;
  }) => {
    logEvent(EventType.LIVE_CLASS_LEFT, data);
  },
  pollIconClicked: (data: {
    poll_id?: string;
    schedule_id?: string;
    received_time?: number;
    start_time?: number;
    player_type?: string;
    socket_status?: string;
    lecture_type?: string;
    source?: string;
  }) => {
    logEvent(EventType.POLL_ICON_CLICKED, data);
  },
  recordPollIconClick: (data: { lecture_type?: 'recorded' }) => {
    logEvent(EventType.POLL_ICON_CLICKED, data);
  },

  cwocImage: (uploadCheck: string) => {
    const body = {
      upload: uploadCheck,
    };
    console.log(body);
    logEvent(EventType.CWOC_IMAGE, body);
  },

  notifyClickEvent: () => {
    console.log('fire');
    logEvent(EventType.NOTIFY_CLICK, []);
  },

  yourCoachLogEvent(popUpType: string) {
    const body = {
      popup_type: popUpType,
    };
    console.log(body);
    logEvent(EventType.your_coach_click, body);
  },

  otherCoachClickEvent: (propType: string) => {
    const body = {
      popup_type: propType,
    };
    console.log(body);
    logEvent(EventType.other_coach_click, body);
  },

  popupCloseEvent: (closePop: string) => {
    const body = {
      popup_type: closePop,
    };
    console.log(body);
    logEvent(EventType.popup_close, body);
  },

  videoPlayerFeature: (data: any) => {
    logEvent(EventType.VIDEO_PLAYER_FEATURE, data);
  },
  mqttConnectionState: (data: any) => {
    logEvent(EventType.MQTT_CONNECTION_STATE, data);
  },
  uSocketConnectionState: (data: any) => {
    logEvent(EventType.U_SOCKET_CONECTION_STATE, data);
  },
  myDoubtSelect: (doubtData: {
    screen_type: string;
    class_type: string;
    type?: string;
    video_id?: string;
    schedule_id?: string;
  }) => {
    const data = {
      ...doubtData,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };

    logEvent(EventType.DE_MYDOUBT_SELECT, data);
  },
  timelineSlideSelect: (timelineData: {
    screen_type: string;
    slide_number?: number;
    class_type: string;
    video_id: string;
    schedule_id: string;
    subtopic?: string;
    section?: string;
  }) => {
    const data = {
      ...timelineData,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };

    logEvent(EventType.TIMELINE_SLIDE_SELECT, data);
  },
  askDoubtSlideSelect: (askDoubtSlideSelectData: {
    batch_id: string;
    schedule_id: string;
    slide_id: string;
    slide_no: number;
    class_type: string;
    video_id: string;
    screen_type: string;
  }) => {
    const data = {
      ...askDoubtSlideSelectData,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };
    logEvent(EventType.ASK_DOUBT_CLICKED, data);
  },
  doubtAskEvent: (doubtAskEventData: { batch_id: string; schedule_id: string }) => {
    const data = {
      ...doubtAskEventData,
    };
    logEvent(EventType.DE_DOUBT_ASK, data);
  },
  doubtNotificationReceiveEvent: (doubtNotificationReceiveEventData: {
    batch_id: string;
    schedule_id: string;
  }) => {
    const data = {
      ...doubtNotificationReceiveEventData,
    };
    logEvent(EventType.DE_NOTIFICATION_RECEIVE, data);
  },
  doubtNotificationOpenEvent: (doubtNotificationOpenEventData: {
    batch_id: string;
    schedule_id: string;
  }) => {
    const data = {
      ...doubtNotificationOpenEventData,
    };
    logEvent(EventType.DE_NOTIFICATION_OPEN, data);
  },
  doubtSectionTab: (doubtSectionClicked: {
    batch_id: string;
    schedule_id: string;
    section_name: string;
    user_name: string;
    screen_type: string;
    class_type: string;
    video_id: string;
  }) => {
    const data = {
      ...doubtSectionClicked,
      UserPhoneNumber: helper.userInfodata().primaryNumber,
    };
    logEvent(EventType.MY_DOUBTS_SECTION_CLICKED, data);
  },

  academic_doubt_act: (academicDoubtAct: {
    video_id: string;
    class_type: string;
    schedule_id: string;
    batch_name: string;
    batch_id: string;
    doubt_text: string;
    subject: string;
  }) => {
    const data = {
      ...academicDoubtAct,
    };
    logEvent(EventType.ACADEMIC_DOUBT_ACT, data);
  },
  doubt_ask: (doubtAsk: {
    video_id: string;
    class_type: string;
    schedule_id: string;
    batch_name: string;
    batch_id: string;
    recommendataion_show: string;
    recommendation_count: number;
    doubt_text: string;
    doubt_type: string;
    subject: string;
  }) => {
    const data = {
      ...doubtAsk,
    };
    logEvent(EventType.DOUBT_ASK, data);
  },

  streamingStarted: (data: {
    video_id: string;
    batch_name: string;

    schedule_id: string;
    schedule_start_time: string;
    off_time: any;
  }) => {
    logEvent(EventType.STREAMING_OFF, data);
  },
  scheduleUpdate: (data: {
    video_id: string;
    batch_name: string;
    schedule_id: string;
    schedule_start_time: string;
    schedule_update_time: any;
  }) => {
    logEvent(EventType.SCHEDULE_UPDATE, data);
  },
  messageSent: (data: {
    product: string;
    module: string;
    batch_name: string;
    subject: string;
    module_name: string;
  }) => {
    logEvent(EventType.MESSAGE_SENT, data);
  },

  notes_redirection_click: (data: {
    screen_type: string;
    redirection_timestamp: number;
    video_id: string;
    schedule_id: string;
  }) => {
    logEvent(EventType.NOTES_REDIRECTION_CLICK, data);
  },
  three_d_list_open: (data: {
    user_name: string;
    subject_id: string;
    schedule_id: string;
    batch_id: string;
    class_type: string;
    cohort_id: string | null;
  }) => {
    logEvent(EventType.THREE_D_LIST_OPEN, data);
  },
  three_d_model_open: (data: {
    user_name: string;
    subject_id: string;
    schedule_id: string;
    batch_id: string;
    class_type: string;
    model_id: string;
    model_name: string;
    model_uri: string;
    cohort_id: string | null;
    model_type: string;
  }) => {
    logEvent(EventType.THREE_D_MODEL_OPEN, data);
  },

  // LOW DATA MODE EVENTS
  ldm_coachmark: (data: {}) => {
    logEvent(EventType.LDM_COACHMARK, data);
  },
  ldm_toggle: (data: { ldm: boolean; reason: string }) => {
    logEvent(EventType.LDM_TOGGLE, data);
  },
  ldm_pip_state: (data: { pip_new_state: string; pip_prev_state: string }) => {
    logEvent(EventType.LDM_PIP_STATE, data);
  },
  ldm_unstable_internet_popup: () => {
    logEvent(EventType.LDM_UNSTABLE_INTERNET_POPUP, {});
  },
  ldm_media_error: (data: { error: string }) => {
    logEvent(EventType.LDM_MEDIA_ERROR, data);
  },
  ldm_unstable_internet_popup_cta: (data: { click_text: string; preference: boolean }) => {
    logEvent(EventType.LDM_UNSTABLE_INTERNET_POPUP_CTA, data);
  },
  ldm_feedback_popup: () => {
    logEvent(EventType.LDM_FEEDBACK_POPUP, {});
  },
  ldm_feedback_submit: (data: { star_rating: Number; checked_text: string }) => {
    logEvent(EventType.LDM_FEEDBACK_SUBMIT, data);
  },
  // Conviva Event

  pw_player_load: (data: {
    // content_type:string;
    schedule_id: string;
  }) => {
    logEvent(EventType.PW_PLAYER_LOAD, { ...data, uuid: convivaUuid });
  },
  pw_conviva_tracking_initialized: (data: {
    content_type: string;
    is_live: any;
    schedule_id: string;
  }) => {
    logEvent(EventType.PW_CONVIVA_TRACKING_INITIALIZED, { ...data, uuid: convivaUuid });
  },
  pw_video_playable: (data: {
    response_success: boolean;
    response_code: number;
    schedule_id: string;
  }) => {
    // CONVIVA event added here
    trackCustomEvent({
      name: EventType.PW_VIDEO_PLAYABLE,
      data,
    });

    logEvent(EventType.PW_VIDEO_PLAYABLE, { ...data, uuid: convivaUuid });
  },
  first_time_video_play: (data: { content_type: string }) => {
    logEvent(EventType.FIRST_TIME_VIDEO_PLAY, { ...data, uuid: convivaUuid });
  },
  pw_signed_cookie: (data: { is_cookie_available: boolean; schedule_id: string }) => {
    logEvent(EventType.PW_SIGNED_COOKIE, { ...data, uuid: convivaUuid });
  },

  // single-scheduling-events
  single_scheduling_attachment_popup: (data: {
    entity_type: string;
    action: string;
    userSegment?: string;
  }) => {
    logEvent(EventType.SINGLE_SCHEDULING_ATTACHMENT_POP, { ...data, source: 'video player' });
  },
  single_scheduling_card_click: (data: { type: string; source: string; userSegment: string }) => {
    logEvent(EventType.SINGLE_SCHEDULING_CARD_CLICK, { ...data });
  },

  video_player_click: (data: { click_text: string; source: string }) => {
    logEvent(EventType.VIDEO_PLAYER_CLICK, { ...data });
  },
  video_save_click: (data: { video_id: string; content_id: string; source: string }) => {
    logEvent(EventType.VIDEO_SAVE_CLICK, { ...data });
  },
  pw_video_player_submit_click: (data: { details_submitted: string; feature_name: string }) => {
    logEvent(EventType.PW_VIDEO_PLAYER_SUBMIT_CLICK, { ...data });
  },
  // post poll
  poll_feedback_submit: (data: {
    poll_id: string;
    star_rating: number;
    page_name: string;
    lecture_type?: string;
  }) => {
    logEvent(EventType.POLL_FEEDBACK_SUBMIT, data);
  },
  poll_submit: (data: { poll_id: string; start_time: Date; type: string; received_time: Date }) => {
    logEvent(EventType.POLL_SUBMIT, data);
  },

  poll_click: (data: {
    click_text: string;
    page_name: string;
    lecture_type?: string;
    poll_id?: string;
    source?: string;
    start_time?: number;
    received_time?: number;
  }) => {
    logEvent(EventType.POLL_CLICK, data);
  },
  poll_action: (data: { action: string; lecture_type?: string; poll_id?: string }) => {
    logEvent(EventType.POLL_ACTION, data);
  },

  poll_open: (data: any) => {
    logEvent(EventType.POLL_OPEN, data);
  },

  // Vernacular GA event
  language_change: (data: { current_value: string; previous_value: string }) => {
    logEvent(EventType.LANGUAGE_CHANGE, { ...data, section: 'video_player_settings' });
  },

  setting_selection: (data: {
    action_type: string;
    class_type: string;
    prev_quality: string;
    prev_speed: number;
    quality: number;
    screen_type: string;
    speed: number;
    video_id: string;
  }) => {
    logEvent(EventType.SETTING_SELECTION, data);
  },

  // periodic sync
  pw_periodic_sync: (data: { session_id: string; counter: number; trigger: string }) => {
    logEvent(EventType.PERIODIC_SYNC, data);
  },

  // lecture leaving
  back_button_click: (data: {
    page_name: string;
    content_id: string;
    content_type: string;
    batch_id: string;
  }) => {
    logEvent(EventType.BACK_BUTTON_CLICK, data);
  },
  leave_lecture_popup_shown: (data: {
    batch_id: string;
    popup_type: string;
    source: string;
    content_id: string;
    content_type: string;
    content_engagement: number;
  }) => {
    logEvent(EventType.POPUP_SHOWN, data);
  },
  leave_lecture_popup_click: (data: {
    batch_id: string;
    popup_type: string;
    source: string;
    action: string;
    content_id: string;
    content_type: string;
  }) => {
    logEvent(EventType.POPUP_CLICK, data);
  },
  leave_lecture_feedback_popup_click: (data: {
    batch_id: string;
    popup_type: string;
    source: string;
    action: string;
    content_id: string;
    content_type: string;
    tag_selected?: any;
    feedback_entered?: string | null;
  }) => {
    logEvent(EventType.FEEDBACK_POPUP_CLICK, data);
  },
  lecture_rating_popup_shown: (data: {
    schedule_id: string;
    lecture_id: string;
    lecture_type: string;
    batch_id: string;
    batch_name: string;
    cohort_id: string;
    session_id: string;
    watch_duration_sec: number;
    watch_percentage: number;
  }) => {
    logEvent(EventType.LECTURE_RATING_POPUP_SHOWN, data);
  },
  lecture_rating_popup_closed: (data: {
    schedule_id: string;
    lecture_id: string;
    lecture_type: string;
    batch_id: string;
    batch_name: string;
    cohort_id: string;
    session_id: string;
    watch_duration_sec: number;
    watch_percentage: number;
  }) => {
    logEvent(EventType.LECTURE_RATING_POPUP_CLOSED, data);
  },
  lecture_rating_submitted: (data: {
    schedule_id: string;
    lecture_id: string;
    lecture_type: string;
    batch_id: string;
    batch_name: string;
    cohort_id: string;
    session_id: string;
    watch_duration_sec: number;
    watch_percentage: number;
    rating: number;
    selected_tags: string[];
    feedback_message: string;
    feedback_text_length: number;
  }) => {
    logEvent(EventType.LECTURE_RATING_SUBMITTED, data);
  },
  lecture_rating_clicked: (data: {
    schedule_id: string;
    lecture_id: string;
    lecture_type: string;
    batch_id: string;
    batch_name: string;
    cohort_id: string;
    session_id: string;
    watch_duration_sec: number;
    watch_percentage: number;
  }) => {
    logEvent(EventType.LECTURE_RATING_CLICKED, data);
  },
  video_completion_toggle: (data: {
    batch_id?: string;
    subject_id?: string;
    selected_value: 'auto_complete';
    scheduleId?: string;
  }) => {
    logEvent(EventType.VIDEO_COMPLETION_TOGGLE, data);
  },

  // Video Copilot Events
  videoCopilotOpenedEvent: (data: { video_id: string; video_type: string }) => {
    logEvent(EventType.VIDEO_COPILOT_CLICK, data);
  },
  videoCopilotInteractionEvent: (data: {
    video_id: string;
    video_type: string;
    cta_type: string;
  }) => {
    logEvent(EventType.VIDEO_COPILOT_INTERACTIONS, data);
  },
  videoCopilotConversationResponseEvent: (data: {
    user_id: string;
    conversation_response: any;
  }) => {
    logEvent(EventType.VIDEO_COPILOT_CONVERSATION_RESPONSE, data);
  },
};

export default eventTracker;
